import * as actionTypes from './../actions/breedAction';

const initialState = {
  selected: null,
  selectedData: [],
  selectedType: null,
  data: [],
  pending: true,
  error: null,
  ready: false,
};

const reducer = ( state = initialState, action ) => {
  switch ( action.type ) {
    case actionTypes.SELECT:
      return {
        ...state,
        selected: action.selected,
        selectedData: state.data.data[state.selectedType][action.selected],
      };
    case actionTypes.DEFAULT:
      return {
        ...state,
        selected: 0,
        selectedData: state.data.data[action.selectedAnimalType][0],
        selectedType: action.selectedAnimalType,
        ready: true,
      };
    case actionTypes.FETCH_DATA_PENDING:
      return {
        ...state,
        pending: true
      };
    case actionTypes.FETCH_DATA_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data
      };
    case actionTypes.FETCH_DATA_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error
      };
    default:
      return state;
  }
};

export default reducer;
